<template>
  <div class="security">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="security_main_body">
        <div class="security_main_body_div">
          <div class="H_sec">亿级代理池资源，全球覆盖</div>
          <div class="text_sec">
            优选全球高质量住宅、数据中心代理，业务成功率高达99.9%，采集全球网页公开数据信息
          </div>
        </div>
        <div class="div_imgs_topdiv">
          <div class="div_imgs">
            <div>
              <img src="http://apiupss.ppfly.top/images/fea1.svg" alt="" />
              <div class="text_img">220+国家地区</div>
            </div>
            <div>
              <img src="http://apiupss.ppfly.top/images/fea2.svg" alt="" />
              <div class="text_img">承载亿级并发</div>
            </div>
            <div>
              <img src="http://apiupss.ppfly.top/images/fea3%20%281%29.svg" alt="" />
              <div class="text_img">城市级定位</div>
            </div>
          </div>
        </div>

        <div class="div_3">
          <div class="div_3_div">
            <div class="H2">热门国家地区</div>
            <div class="H3">我们提供更多的国家IP资源</div>
            <div class="num_gj">
              <div>
                <div class="gj_img">
                  <img
                    src="http://apiupss.ppfly.top/images/flag_1%20%281%29.svg"
                    alt=""
                  />
                  <div>
                    <div class="gj_img_H1">美国</div>
                    <div class="gj_img_H2">10,903,980个IP</div>
                  </div>
                </div>

                <div class="gj_img">
                  <img
                    src="http://apiupss.ppfly.top/images/flag_2%20%281%29.svg"
                    alt=""
                  />
                  <div>
                    <div class="gj_img_H1">英国</div>
                    <div class="gj_img_H2">3,903,550个IP</div>
                  </div>
                </div>

                <div class="gj_img">
                  <img
                    src="http://apiupss.ppfly.top/images/fea3.svg"
                    alt=""
                  />
                  <div>
                    <div class="gj_img_H1">加拿大</div>
                    <div class="gj_img_H2">12,103,580个IP</div>
                  </div>
                </div>

                <div class="gj_img">
                  <img
                    src="http://apiupss.ppfly.top/images/flag_4.svg"
                    alt=""
                  />
                  <div>
                    <div class="gj_img_H1">泰国</div>
                    <div class="gj_img_H2">804,671个IP</div>
                  </div>
                </div>
              </div>

              <div>
                <div class="gj_img">
                  <img
                    src="http://apiupss.ppfly.top/images/flag_5.svg"
                    alt=""
                  />
                  <div>
                    <div class="gj_img_H1">印度尼西亚</div>
                    <div class="gj_img_H2">1,574,127个IP</div>
                  </div>
                </div>

                <div class="gj_img">
                  <img
                    src="http://apiupss.ppfly.top/images/flag_6.svg"
                    alt=""
                  />
                  <div>
                    <div class="gj_img_H1">印度</div>
                    <div class="gj_img_H2">9,077,144个IP</div>
                  </div>
                </div>

                <div class="gj_img">
                  <img
                    src="http://apiupss.ppfly.top/images/flag_7.svg"
                    alt=""
                  />
                  <div>
                    <div class="gj_img_H1">马来西亚</div>
                    <div class="gj_img_H2">584,675个IP</div>
                  </div>
                </div>

                <div class="gj_img">
                  <img
                    src="http://apiupss.ppfly.top/images/flag_8.svg"
                    alt=""
                  />
                  <div>
                    <div class="gj_img_H1">韩国</div>
                    <div class="gj_img_H2">453,980个IP</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="div_3">
          <div class="div_3_div">
            <div class="H2">全部国家列表</div>
            <div class="H3">满足您对各个地区的使用需求</div>
          </div>

          <div class="div_4">
            <div>
              <div class="input_div">
                <el-input
                  placeholder="请输国家名称或代码"
                  v-model="gouname"
                ></el-input>
              </div>
              <!-- gj_data -->
              <div v-for="list in gj_data" :key="list.lable">
                <div>
                  <div class="H_qq">{{ list.lable }}</div>
                </div>
                <div>
                  <div style="text-align: left">
                    <a
                      class="a_text"
                      v-for="listins in list.datalist"
                      :key="listins.gjname"
                      ><span class="a_texttype"
                        >{{ listins.gjname }} - {{ listins.gjdaima }}</span
                      ></a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="div_3">
          <div class="div_3_div">
            <div class="H2">多种代理类型，满足业务需求</div>
          </div>

          <div class="div_4">
            <div class="div_div_5">
              <div class="div_5">
                <div class="div_5_div">
                  <img
                    src="http://apiupss.ppfly.top/images/pck_card1.svg"
                    alt=""
                  />
                  <div class="div_5_div_H">动态住宅代理</div>
                  <div class="div_5_div_text">真实匿名的家庭住宅IP</div>
                  <div class="div_5_div_butts">免费测试</div>
                </div>
                <div>
                  <div class="div_5_div_li"><li>220+国家地区可选</li></div>
                  <div class="div_5_div_li"><li>无限并发会话</li></div>
                  <div class="div_5_div_li"><li>指定国家/城市/运营商</li></div>
                  <div class="div_5_div_li"><li>1-120min IP切换时效</li></div>
                </div>
              </div>

              <div class="div_5">
                <div class="div_5_div">
                  <img
                    src="http://apiupss.ppfly.top/images/pck_card2.svg"
                    alt=""
                  />
                  <div class="div_5_div_H">静态住宅代理</div>
                  <div class="div_5_div_text">长效独享的真人住宅ISP</div>
                  <div class="div_5_div_butts">免费测试</div>
                </div>
                <div>
                  <div class="div_5_div_li"><li>100+国家地区可选</li></div>
                  <div class="div_5_div_li"><li>真实家庭ISP属性</li></div>
                  <div class="div_5_div_li"><li>不限使用流量</li></div>
                  <div class="div_5_div_li"><li>独享带宽配速</li></div>
                </div>
              </div>


              <div class="div_5">
                <div class="div_5_div">
                  <img
                    src="http://apiupss.ppfly.top/images/pck_card3.svg"
                    alt=""
                  />
                  <div class="div_5_div_H">数据中心代理</div>
                  <div class="div_5_div_text">独享&动态数据中心IP</div>
                  <div class="div_5_div_butts">免费测试</div>
                </div>
                <div>
                  <div class="div_5_div_li"><li>300万+代理池</li></div>
                  <div class="div_5_div_li"><li>无限并发会话</li></div>
                  <div class="div_5_div_li"><li>优选全球数据中心</li></div>
                  <div class="div_5_div_li"><li>HTTP(S)/Socks5协议</li></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer></Footer>
      </el-main>
    </el-container>
    <Xuanfuret></Xuanfuret>
  </div>
</template>

<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
export default {
  components: {
    Head,
    Footer,
    Xuanfuret,
  },
  data() {
    return {
      gouname: "",
      gj_data: [
        {
          lable: "亚洲",
          datalist: [
            { gjname: "韩国", gjdaima: "kr" },
            { gjname: "日本", gjdaima: "jp" },
            { gjname: "菲律宾", gjdaima: "ph" },
            { gjname: "越南", gjdaima: "vn" },
            { gjname: "印度", gjdaima: "in" },
            { gjname: "缅甸", gjdaima: "mm" },
            { gjname: "泰国", gjdaima: "th" },
            { gjname: "马来西亚", gjdaima: "my" },
            { gjname: "印度尼西亚", gjdaima: "id" },
            { gjname: "孟加拉国", gjdaima: "bd" },
            { gjname: "不丹", gjdaima: "bt" },
            { gjname: "马尔代夫", gjdaima: "mv" },
            { gjname: "尼泊尔", gjdaima: "np" },
            { gjname: "巴基斯坦", gjdaima: "pk" },
            { gjname: "斯里兰卡", gjdaima: "lk" },
            { gjname: "巴林", gjdaima: "bh" },
            { gjname: "科威特", gjdaima: "kw" },
            { gjname: "瑞典", gjdaima: "se" },
            { gjname: "卡塔尔", gjdaima: "qa" },
            { gjname: "沙特拉贾伯", gjdaima: "sa" },
            { gjname: "也门", gjdaima: "ye" },
            { gjname: "塞浦路斯", gjdaima: "cy" },
            { gjname: "以色列", gjdaima: "il" },
            { gjname: "约旦", gjdaima: "jo" },
            { gjname: "黎巴嫩", gjdaima: "lb" },
            { gjname: "巴勒斯坦", gjdaima: "ps" },
            { gjname: "叙利亚", gjdaima: "sy" },
            { gjname: "阿富汗", gjdaima: "af" },
            { gjname: "亚美尼亚", gjdaima: "am" },
            { gjname: "阿塞拜疆", gjdaima: "az" },
            { gjname: "土耳其", gjdaima: "tr" },
            { gjname: "哈萨克斯坦", gjdaima: "kz" },
            { gjname: "吉尔吉斯斯坦", gjdaima: "kg" },
            { gjname: "塔吉克斯坦", gjdaima: "tj" },
            { gjname: "乌兹别克斯坦", gjdaima: "uz" },
            { gjname: "格鲁吉亚", gjdaima: "ge" },
            { gjname: "东帝汶", gjdaima: "tl" },
            { gjname: "新加坡", gjdaima: "sg" },
            { gjname: "文莱", gjdaima: "bn" },
            { gjname: "柬埔寨", gjdaima: "kh" },
            { gjname: "老挝", gjdaima: "la" },
            { gjname: "蒙古国", gjdaima: "mn" },
          ],
        },
        {
          lable: "欧洲",
          datalist: [
            { gjname: "法国", gjdaima: "fr" },
            { gjname: "英国", gjdaima: "gb" },
            { gjname: "意大利", gjdaima: "it" },
            { gjname: "德国", gjdaima: "de" },
            { gjname: "卢森堡", gjdaima: "lu" },
            { gjname: "比利时", gjdaima: "be" },
            { gjname: "奥地利", gjdaima: "at" },
            { gjname: "西班牙", gjdaima: "es" },
            { gjname: "爱尔兰", gjdaima: "ie" },
            { gjname: "芬兰", gjdaima: "fi" },
            { gjname: "梵蒂冈", gjdaima: "va" },
            { gjname: "葡萄牙", gjdaima: "pt" },
            { gjname: "拉脱维亚", gjdaima: "lv" },
            { gjname: "波兰", gjdaima: "pl" },
            { gjname: "立陶宛", gjdaima: "lt" },
            { gjname: "匈牙利", gjdaima: "hu" },
            { gjname: "摩尔多瓦", gjdaima: "md" },
            { gjname: "荷兰", gjdaima: "nl" },
            { gjname: "瑞士", gjdaima: "ch" },
            { gjname: "摩纳哥", gjdaima: "mc" },
            { gjname: "捷克共和国", gjdaima: "cz" },
            { gjname: "挪威", gjdaima: "no" },
            { gjname: "冰岛", gjdaima: "is" },
            { gjname: "希腊", gjdaima: "gr" },
            { gjname: "马耳他", gjdaima: "mt" },
            { gjname: "爱沙尼亚", gjdaima: "ee" },
            { gjname: "克罗地亚", gjdaima: "hr" },
            { gjname: "阿尔巴尼亚", gjdaima: "al" },
            { gjname: "波黑", gjdaima: "ba" },
            { gjname: "保加利亚", gjdaima: "bg" },
            { gjname: "丹麦", gjdaima: "dk" },
            { gjname: "黑山", gjdaima: "me" },
            { gjname: "马其顿", gjdaima: "mk" },
            { gjname: "罗马尼亚", gjdaima: "ro" },
            { gjname: "塞尔维亚", gjdaima: "rs" },
            { gjname: "斯洛文尼亚", gjdaima: "si" },
            { gjname: "斯洛伐克", gjdaima: "sk" },
            { gjname: "科索沃", gjdaima: "xk" },
            { gjname: "安道尔公国", gjdaima: "ad" },
            { gjname: "泽西岛", gjdaima: "je" },
            { gjname: "马恩岛", gjdaima: "im" },
            { gjname: "根西岛", gjdaima: "gg" },
            { gjname: "列支敦士登", gjdaima: "li" },
            { gjname: "欧洲", gjdaima: "eu" },
            { gjname: "直布罗陀", gjdaima: "gi" },
            { gjname: "格陵兰", gjdaima: "gl" },
          ],
        },

        {
          lable: "北美洲",
          datalist: [
            { gjname: "美国", gjdaima: "us" },
            { gjname: "加拿大", gjdaima: "ca" },
            { gjname: "牙买加", gjdaima: "jm" },
            { gjname: "圣卢西亚", gjdaima: "lc" },
            { gjname: "墨西哥", gjdaima: "mx" },
            { gjname: "巴拿马", gjdaima: "pa" },
            { gjname: "阿鲁巴", gjdaima: "aw" },
            { gjname: "哥斯达黎加", gjdaima: "cr" },
            { gjname: "库拉索", gjdaima: "cw" },
            { gjname: "多米尼加", gjdaima: "do" },
            { gjname: "瓜德罗普", gjdaima: "gp" },
            { gjname: "危地马拉", gjdaima: "gt" },
            { gjname: "洪都拉斯", gjdaima: "hn" },
            { gjname: "波多黎各", gjdaima: "pr" },
            { gjname: "萨尔瓦多", gjdaima: "sv" },
            { gjname: "特立尼达和多巴哥", gjdaima: "tt" },
            { gjname: "巴哈马", gjdaima: "bs" },
            { gjname: "多米尼加共和国", gjdaima: "dm" },
            { gjname: "伯利兹", gjdaima: "bz" },
            { gjname: "巴巴多斯", gjdaima: "bb" },
            { gjname: "荷属圣马丁", gjdaima: "sx" },
            { gjname: "圣文森特岛", gjdaima: "vc" },
            { gjname: "安提瓜和巴布达", gjdaima: "ag" },
            { gjname: "尼加拉瓜", gjdaima: "ni" },
            { gjname: "海地共和国", gjdaima: "ht" },
            { gjname: "开曼群岛", gjdaima: "ky" },
            { gjname: "法属圣马丁", gjdaima: "mf" },
            { gjname: "美属维尔京群岛", gjdaima: "vi" },
            { gjname: "美属维尔京群岛", gjdaima: "wf" },
            { gjname: "马提尼克", gjdaima: "mq" },
            { gjname: "英属维尔京群岛", gjdaima: "vg" },
            { gjname: "圣基茨和尼维斯", gjdaima: "kn" },
            { gjname: "百慕大", gjdaima: "bm" },
          ],
        },

        {
          lable: "南美洲",
          datalist: [
            { gjname: "阿根廷", gjdaima: "ar" },
            { gjname: "巴西", gjdaima: "br" },
            { gjname: "哥伦比亚", gjdaima: "co" },
            { gjname: "智利", gjdaima: "cl" },
            { gjname: "委内瑞拉", gjdaima: "ve" },
            { gjname: "秘鲁", gjdaima: "pe" },
            { gjname: "玻利维亚", gjdaima: "bo" },
            { gjname: "厄瓜多尔", gjdaima: "ec" },
            { gjname: "圭亚那", gjdaima: "gy" },
            { gjname: "巴拉圭", gjdaima: "py" },
            { gjname: "乌拉圭", gjdaima: "uy" },
            { gjname: "苏里南", gjdaima: "sr" },
            { gjname: "法属圭亚那", gjdaima: "gf" },
          ],
        },

        {
          lable: "大洋洲",
          datalist: [
            { gjname: "新西兰", gjdaima: "nz" },
            { gjname: "帕劳", gjdaima: "pw" },
            { gjname: "澳大利亚", gjdaima: "au" },
            { gjname: "斐济群岛", gjdaima: "fj" },
            { gjname: "巴布亚新几内亚", gjdaima: "pg" },
            { gjname: "新喀里多尼亚", gjdaima: "nc" },
            { gjname: "法属波利尼西亚", gjdaima: "pf" },
            { gjname: "关岛", gjdaima: "gu" },
            { gjname: "托克劳", gjdaima: "tk" },
            { gjname: "密克罗尼西亚联邦", gjdaima: "fm" },
            { gjname: "所罗门群岛", gjdaima: "sb" },
            { gjname: "瓦努阿图", gjdaima: "vu" },
            { gjname: "美属萨摩亚", gjdaima: "as" },
          ],
        },

        {
          lable: "非洲",
          datalist: [
            { gjname: "马达加斯加", gjdaima: "mg" },
            { gjname: "莫桑比克", gjdaima: "mz" },
            { gjname: "南非", gjdaima: "za" },
            { gjname: "埃塞俄比亚", gjdaima: "et" },
            { gjname: "肯尼亚", gjdaima: "ke" },
            { gjname: "加纳", gjdaima: "gh" },
            { gjname: "尼日利亚", gjdaima: "ng" },
            { gjname: "安哥拉", gjdaima: "ao" },
            { gjname: "布基纳法索", gjdaima: "bf" },
            { gjname: "贝宁", gjdaima: "bj" },
            { gjname: "博茨瓦纳", gjdaima: "bw" },
            { gjname: "刚果(布)", gjdaima: "cg" },
            { gjname: "科特迪瓦", gjdaima: "ci" },
            { gjname: "埃尔及利亚", gjdaima: "dz" },
            { gjname: "埃及", gjdaima: "eg" },
            { gjname: "加蓬", gjdaima: "ga" },
            { gjname: "利比亚", gjdaima: "ly" },
            { gjname: "摩洛哥", gjdaima: "ma" },
            { gjname: "马里", gjdaima: "ml" },
            { gjname: "毛里求斯", gjdaima: "mu" },
            { gjname: "纳米比亚", gjdaima: "na" },
            { gjname: "留尼汪", gjdaima: "re" },
            { gjname: "卢旺达", gjdaima: "rw" },
            { gjname: "苏丹", gjdaima: "sd" },
            { gjname: "塞内加尔", gjdaima: "sn" },
            { gjname: "南苏丹", gjdaima: "ss" },
            { gjname: "多哥", gjdaima: "tg" },
            { gjname: "突尼斯", gjdaima: "tn" },
            { gjname: "乌干达", gjdaima: "ug" },
            { gjname: "津巴布韦", gjdaima: "zw" },
            { gjname: "丹桑尼亚", gjdaima: "tz" },
            { gjname: "毛里塔尼亚", gjdaima: "mr" },
            { gjname: "索马里", gjdaima: "so" },
            { gjname: "冈比亚", gjdaima: "gm" },
            { gjname: "格林纳达", gjdaima: "gd" },
            { gjname: "刚果金", gjdaima: "cd" },
            { gjname: "柯麦隆", gjdaima: "cm" },
            { gjname: "赞比亚共和国", gjdaima: "zm" },
            { gjname: "圣多美和普林西比", gjdaima: "st" },
            { gjname: "佛得角共和国", gjdaima: "cv" },
            { gjname: "赤道几内亚", gjdaima: "gq" },
            { gjname: "马拉维", gjdaima: "mw" },
            { gjname: "吉布提国家", gjdaima: "dj" },
            { gjname: "几内亚", gjdaima: "gn" },
            { gjname: "利比里亚", gjdaima: "lr" },
            { gjname: "尼日尔共和国", gjdaima: "ne" },
            { gjname: "几内亚比绍", gjdaima: "gw" },
            { gjname: "塞拉利昂", gjdaima: "sl" },
            { gjname: "莱索托", gjdaima: "ls" },
            { gjname: "斯威士兰", gjdaima: "sz" },
            { gjname: "科摩罗", gjdaima: "km" },
            { gjname: "塞舌尔共和国", gjdaima: "sc" },
            { gjname: "马约特", gjdaima: "yt" },
          ],
        },
      ],
    };
  },

  mounted() {},
  methods: {},
};
</script>
<style scoped>
.el-header,
.el-footer {
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0;
}

.el-header {
  position: sticky;
  top: 0;
  background-color: #edf3fc;
  z-index: 5;
}

.security {
  position: relative;
}

.heads_top {
  position: absolute;
}

.H_sec {
  font-size: 54px;
  color: #1b2336;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
}

.security_main_body {
  margin-top: 20px;
}

.security_main_body_div_B {
  margin-top: 240px;
}

.security_main_body_div_B_H {
  font-size: 40px;
  color: #1b2336;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
}

.text_sec {
  max-width: 885px;
  width: 100%;
  text-align: center;
  font-size: 20px;
  color: rgba(18, 17, 39, 0.72);
  margin: 24px auto 0;
}

.text_sec_B {
  font-size: 17px;
  color: #545364;
  text-align: center;
  margin-top: 24px;
}

.security_main_body_div {
  margin-top: 50px;
}

.text_div_C {
  display: flex;
  justify-content: center;
}

.div_imgs {
  display: flex;
  justify-content: space-between;
  width: 1000px;
  margin: 0;
}
.div_imgs_topdiv {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.text_img {
  font-family: SourceHanSansCN-Medium;
  font-size: 22px;
  color: #1b2336;
  margin-top: 20px;
}
.div_3 {
  margin-top: 200px;
}
.H2 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
}
.H3 {
  font-weight: 400;
  font-size: 18px;
  color: #565656;
  text-align: center;
  margin-top: 29px;
}
.gj_img {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 15px;
}
.gj_img > img {
  width: 58px;
  height: 58px;
  margin-right: 20px;
}
.gj_img_H1 {
  text-align: left;
  font-weight: 400;
  font-size: 18px;
  color: #707070;
}
.gj_img_H2 {
  text-align: left;
  font-family: SourceHanSansCN-Medium;
  font-size: 21px;
  color: #242331;
}
.num_gj > div {
  margin: 60px;
  display: flex;
  justify-content: center;
}
.el-select .el-input {
  width: 130px;
}
.div_4 {
  display: flex;
  justify-content: center;
}
.div_4 > div {
  margin-top: 50px;
  width: 1400px;
}
.H_qq {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 30px;
  color: #292626;
  width: 100px;
  background: #edf3fc;
  text-align: right;
  margin-top: 30px;
  margin-bottom: 30px;
}
.a_text {
  display: inline-block;
  padding: 8px;
  text-align: left;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  max-width: 214px;
  height: 56px;
  box-sizing: border-box;
  border-radius: 10px;
  background: #f8fbff;
  border: 1px solid #a0c1f7;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 20px;
}
.a_texttype {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 20px;
  color: #13497f;
}
.input_div {
  width: 1320px;
  margin: 0 auto;
}
.div_5_div_H {
  font-family: SourceHanSansCN-Medium;
  font-size: 30px;
  color: #071223;
  margin-top: 33px;
  text-align: center;
  font-weight: 500;
}
.div_5_div_text {
  font-weight: 400;
  font-size: 18px;
  color: #565656;
  margin-top: 23px;
  text-align: center;
}
.div_5_div_butts {
    display: block;
    height: 48px;
    background: #f1f6ff;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    color: #2c6bd7;
    line-height: 48px;
    text-align: center;
    margin-top: 37px;
    margin-bottom: 47px;
}

.div_div_5{
    display: flex;
    justify-content: space-between;
}
.div_5_div_li {
  margin-bottom: 24px;
  font-weight: 400;
  font-size: 14px;
  color: #364050;
  line-height: 22px;
  display: flex;
  align-items: center;
}
.div_5{
    width: 280px;
    padding: 20px;
    border-radius: 12px;
}
.div_5:hover{
    box-shadow: #2c6bd7 0px 1px 4px, #2c6bd7 0px 0px 0px 3px;
}
.div_5:hover .div_5_div_butts{
    display: block;
    height: 48px;
    background: #2c6bd7;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    color: #f1f6ff;
    line-height: 48px;
    text-align: center;
    margin-top: 37px;
    margin-bottom: 47px;
}
/* .p1:hover ~ .d1{
	background-color: #edf3fc;
} */
</style>